import { render, staticRenderFns } from "./orderPaySuccess.vue?vue&type=template&id=c08b7d8c&scoped=true"
import script from "./orderPaySuccess.vue?vue&type=script&lang=js"
export * from "./orderPaySuccess.vue?vue&type=script&lang=js"
import style0 from "./orderPaySuccess.vue?vue&type=style&index=0&id=c08b7d8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08b7d8c",
  null
  
)

export default component.exports